import { useSelector } from 'hooks/utils';
import { selectProjectOwnerDetails } from 'store/data/projects';

export function useProjectOwnerDetails() {
	return useSelector(state => selectProjectOwnerDetails(state.data.projects));
}
